import React from 'react'
import { Box, Container, Paper, SimpleGrid, Text } from '@mantine/core'
import { IconX } from '@tabler/icons-react'
import SectionHeader from './shared/SectionHeader'
import { BOUNDARY_CONTENT } from '../utils/constants'

export default function Boundary() {
  return (
    <Box id="boundary" py={{ base: 60, md: 100 }} style={{ backgroundColor: '#FFFFFF' }}>
      <Container size="xl">
        <SectionHeader badge={BOUNDARY_CONTENT.badge} title={BOUNDARY_CONTENT.title} centered />

        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg" mt={40}>
          {BOUNDARY_CONTENT.boundaries.map((item, index) => (
            <Paper
              key={index}
              p="xl"
              radius="lg"
              style={{
                backgroundColor: '#FEF2F2',
                border: '1px solid #FECACA',
              }}
            >
              <Box style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                <Box
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '10px',
                    backgroundColor: '#FEE2E2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <IconX size={20} color="#DC2626" />
                </Box>
                <Text size="md" c="#991B1B" fw={500} style={{ lineHeight: 1.6 }}>
                  {item.text}
                </Text>
              </Box>
            </Paper>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
